import { Directive, ElementRef, inject, afterRenderEffect, HostListener } from "@angular/core";

@Directive({
    selector: "[wkAutoWidth]",
    exportAs: "wkAutoWidth",
})
export class WkAutoWidthDirective {
    private readonly el = inject(ElementRef<HTMLElement>);

    constructor() {
        afterRenderEffect(() => {
            this.check();
        });
    }

    private check() {
        const el = this.el.nativeElement;
        if (!el) return;

        const input = el.querySelector("input") as HTMLInputElement | null;
        if (!input) return;

        if (input.value) {
            input.style.width = "120px";
            return;
        }

        const styles = window.getComputedStyle(input);
        const font = `${styles.fontWeight} ${styles.fontSize} ${styles.fontFamily}`;

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        if (context) {
            const text = input.value || input.placeholder || "";
            context.font = font;
            const textWidth = context.measureText(text).width + 6;

            const paddingLeft = Number.parseFloat(styles.paddingLeft);
            const paddingRight = Number.parseFloat(styles.paddingRight);
            const borderLeft = Number.parseFloat(styles.borderLeftWidth);
            const borderRight = Number.parseFloat(styles.borderRightWidth);

            const totalWidthInPx = textWidth + paddingLeft + paddingRight + borderLeft + borderRight;

            input.style.width = `${totalWidthInPx}px`;
        }
    }

    @HostListener("valueChange")
    onInput() {
        this.check();
    }
}
